import search from "./search.json";
import result from "./result.json";

const QuickReservationConfig = {
  search,
  result
};

export default QuickReservationConfig;
